module.exports = __webpack_public_path__ + "img/flyer-1.36aaee12.png";